export { HousemateDetailsModule } from './HousemateDetailsModule';
export { getHousemateDetailsDisplay, hasHousemateDetails } from './housemateDetailsModule.utils';
